// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle-button_icon__2FiQ2{\n    display: inline-block !important;\n    cursor: pointer;\n}\n", "",{"version":3,"sources":["webpack://src/components/toggle-button/toggle-button.module.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,eAAe;AACnB","sourcesContent":[".icon{\n    display: inline-block !important;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "toggle-button_icon__2FiQ2"
};
export default ___CSS_LOADER_EXPORT___;
